import { axiosInstance } from 'api/apiConfig'
import { useMutation, useQuery } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

//댓글조회
const commentList = async (params) => {
  const { data } = await axiosInstance.get(`api/common/cmnt/v1.0/selectCmnt${params}`)
  return data
}

export const useCommentList = (params, isInit) => {
  return useQuery(['commentList'], () => commentList(objectToQueryString(params)), {
    enabled: isInit,
  })
}

//댓글저장
const commentRegist = async (params) => {
  const { data } = await axiosInstance.post('api/common/cmnt/v1.0/insertCmnt', params)
  return data
}

export const useCommentRegist = ({ successHandler, errorHandler }) => {
  return useMutation((params) => commentRegist(params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

//댓글수정
const commentUpdate = async (params) => {
  const { data } = await axiosInstance.post('api/common/cmnt/v1.0/updateCmnt', params)
  return data
}

export const useCommentUpdate = ({ successHandler, errorHandler }) => {
  return useMutation((params) => commentUpdate(params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

//댓글삭제
const commentDelete = async (params) => {
  const { data } = await axiosInstance.post('api/common/cmnt/v1.0/deleteCmnt', params)
  return data
}

export const useCommentDelete = ({ successHandler, errorHandler }) => {
  return useMutation((params) => commentDelete(params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}